<template>
    <div>
        <div v-if="items.length && title.length" class="text-body-2">
            {{ title }}
        </div>
        <v-chip-group column :class="{ outlined: outlined }">
            <v-chip
                v-show="showClearAll"
                v-bind="itemProps"
                :close="false"
                @click="onClearAll"
                >Clear All</v-chip
            >
            <v-chip
                v-for="(item, index) in expandedItems"
                :key="`item-${index}`"
                v-bind="itemProps"
                @click:close="onItemClose(item)"
            >
                {{ item.text }}: {{ item.value }}
            </v-chip>
        </v-chip-group>
    </div>
</template>

<script>
import { VChipGroup } from 'vuetify/lib';

export default {
    name: 'FilterChips',
    components: {
        'v-chip-group': VChipGroup
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        itemProps: {
            type: Object,
            required: false,
            default: () => ({
                small: true,
                close: true,
                color: 'primary'
            })
        },
        outlined: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: 'Active filters'
        }
    },
    computed: {
        expandedItems() {
            let result = [];
            this.items.forEach(item => {
                if (item && Array.isArray(item.value)) {
                    result.push(
                        ...item.value.map(subItem => ({
                            name: item.name,
                            text: item.text,
                            value: subItem,
                            sub: true
                        }))
                    );
                } else {
                    result.push(item);
                }
            });
            return result;
        },
        isLightMode() {
            return !this.$vuetify.theme.dark;
        },
        showClearAll() {
            return this.expandedItems && this.expandedItems.length > 1;
        }
    },
    methods: {
        // =================== Events ======================
        onItemClose(item) {
            const newItems = this.removeFilterChip(this.items, item);
            this.$emit('change', newItems);
        },
        onClearAll() {
            this.$emit('change', []);
        },
        // ==================== Others =====================
        removeFilterChip(source, itemToRemove) {
            // will remove an item from the source
            if (source && itemToRemove) {
                const restItems = source.filter(
                    item => item.name !== itemToRemove.name
                );
                if (itemToRemove.sub) {
                    // if the itemToRemove is a sub item from a value array
                    const targetItem = source.find(
                        item => item.name === itemToRemove.name
                    );
                    if (
                        targetItem &&
                        targetItem.value &&
                        targetItem.value.length
                    ) {
                        const newValue = targetItem.value.filter(
                            item => item !== itemToRemove.value
                        );
                        if (newValue.length) {
                            return [
                                ...restItems,
                                { ...targetItem, value: newValue }
                            ];
                        }
                    }
                }
                return restItems;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-chip-group {
    &.outlined {
        border-style: solid;
        border-width: 1px;
        border-radius: 4px;
        padding-left: 4px;
        padding-right: 4px;
    }
}
.theme--light.v-chip.primary {
    color: map-get($shades, 'white') !important;
}
</style>
